
    document.addEventListener('DOMContentLoaded', function () {
        var countdownMinutes = 15;  // Número de minutos que deseas que dure el cronómetro
        var countdownTimerElement = document.getElementById('countdown-timer');

        function startCountdown() {
            var endTime = new Date().getTime() + countdownMinutes * 60 * 1000;

            var countdownInterval = setInterval(function () {
                var now = new Date().getTime();
                var distance = endTime - now;

                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                countdownTimerElement.textContent = 
                    ('0' + hours).slice(-2) + ":" + 
                    ('0' + minutes).slice(-2) + ":" + 
                    ('0' + seconds).slice(-2);

                if (distance < 0) {
                    clearInterval(countdownInterval);
                    countdownTimerElement.textContent = "00:00:00";
                    startCountdown();  // Reiniciar el cronómetro
                }
            }, 1000);
        }

        startCountdown();
    });

